module.exports = __webpack_public_path__ + "static/media/MILI KECIL.39c79812.png";